import React, {  Component } from 'react';
import { connect } from 'react-redux';

/*Actions*/
import {
	getDocuments
} from '../../../../redux/actions';

class BrandGuidelines extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: ''
		}
	}

	componentDidMount() {
		const { resources } = this.props.state;
		const self = this;
		self.setState({
			errorMessage: ''
		})
		if(!resources.documents) {
			// second param says whether it needs to be saved into store
			self.props.getDocuments('requestType=brandGuideLines', true, response => {
				if(!response.status) {
					self.setState({
						errorMessage: 'Error occured while fetching documents.'
					})
				}
			});
		}
	}
	handleGetHelpDocuments(docId, fileExtension, docName, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			errorMessage: ''
		});

		// second param says whether it needs to be saved into store
		self.props.getDocuments(`requestType=brandGuideLines&docId=${docId}&docName=${docName}&docType=${fileExtension}`, false, response => {
			if(!response.status) {
				self.setState({
					errorMessage: 'Error occured while fetching documents.'
				})
			} else {
				window.open(response.responseObject, '_blank');
			}
		});
	}

    render() {
		const { resources } = this.props.state;
		let documents = null;
		if(resources.documents && resources.documents.responseObject) {
			documents = JSON.parse(JSON.stringify(resources.documents.responseObject.filter(itm => itm.fileExtension === 'pdf')));
		}
	    return (
			<div>
		        <h1 className="pageTitle" style={{margin: '21px 0'}}>Brand Guidelines & Logos</h1>
				<p className="bold red">{this.state.errorMessage}</p>
		        <div className="searchResults">
					<table className="dataTable" width="70%">
						<thead>
							<tr>
								<th>Document</th>
							</tr>
						</thead>
			            <tbody>
							{<tr>
								<td colSpan={2}><a href="https://brandfolder.com/s/6k64js4crssvp7vxqbzp45f" target="_blank">Download House of Brands Logos</a></td>
							</tr>}
						</tbody>
					</table>
		          	<div className="clear" />
				</div>
			</div>
	    );
  	}
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getDocuments: (queryStringParams, willSaveToStore, callback) => dispatch(getDocuments(queryStringParams, willSaveToStore, callback)),
});

BrandGuidelines = connect(mapStateToProps, mapDispatchToProps)(BrandGuidelines);
export default BrandGuidelines;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/BrandGuidelines/index.js